/* ============================================================
   MOONLIGHT SAUNA & WELLNESS — THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- HERO SLIDER ----
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.slider-dot');
  let current = 0;
  let autoplayTimer;

  function showSlide(idx) {
    slides.forEach(function(s, i) {
      s.classList.toggle('is-active', i === idx);
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', i === idx);
    });
    current = idx;
  }

  function nextSlide() { showSlide((current + 1) % slides.length); }
  function prevSlide() { showSlide((current - 1 + slides.length) % slides.length); }
  function startAutoplay() { autoplayTimer = setInterval(nextSlide, 5000); }
  function stopAutoplay() { clearInterval(autoplayTimer); }

  if (slides.length > 0) {
    showSlide(0);
    startAutoplay();

    // Arrow buttons use IDs slider-prev and slider-next
    var nextBtn = document.getElementById('slider-next');
    var prevBtn = document.getElementById('slider-prev');

    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); nextSlide(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); prevSlide(); startAutoplay(); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { stopAutoplay(); showSlide(i); startAutoplay(); });
    });

    // Touch/swipe support
    var touchStartX = 0;
    var sliderEl = document.querySelector('.hero-slider');
    if (sliderEl) {
      sliderEl.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      sliderEl.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          stopAutoplay();
          if (diff > 0) nextSlide(); else prevSlide();
          startAutoplay();
        }
      }, { passive: true });
    }
  }

  // ---- MOBILE MENU ----
  var mobileToggle = document.querySelector('.mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileClose = document.getElementById('mobile-menu-close');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function() {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }



  // ---- PRODUCT GALLERY THUMBNAILS ----
  // Matches .gallery-thumb elements in product.liquid
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('gallery-main-img');
      var thumbImg = this.querySelector('img');
      var src = thumbImg ? thumbImg.getAttribute('data-full') : null;
      if (mainImg && src) {
        // The main <img> carries a srcset, and a browser ignores .src while a
        // srcset is set, so without this the picture never changed. Swap the
        // srcset to this image's (or clear it) so the chosen photo shows, sharp.
        mainImg.srcset = (thumbImg.getAttribute('data-srcset') || '');
        mainImg.sizes = '(min-width: 900px) 620px, 100vw';
        mainImg.src = src;
      }
      document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });
  // ---- VARIANT BUTTONS ----
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  // ---- QUANTITY SELECTOR ----
  window.adjustQty = function(delta) {
    var input = document.getElementById('qty-input');
    var hidden = document.getElementById('qty-hidden');
    if (!input) return;
    var val = Math.max(1, parseInt(input.value || 1) + delta);
    input.value = val;
    if (hidden) hidden.value = val;
  };

  // Sync qty input to hidden field on change
  var qtyInput = document.getElementById('qty-input');
  if (qtyInput) {
    qtyInput.addEventListener('change', function() {
      var hidden = document.getElementById('qty-hidden');
      if (hidden) hidden.value = this.value;
    });
  }

  // ---- STICKY HEADER SHADOW ----
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 12px rgba(0,0,0,0.12)' : '0 1px 4px rgba(0,0,0,0.08)';
    });
  }

  // ---- CART COUNT (Shopify Ajax) ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      })
      .catch(function() {});
  }
  updateCartCount();

  // ---- ADD TO CART (AJAX) ----
  // Product form uses Shopify's {% form 'product', product %} which adds action="/cart/add"
  // We intercept it for AJAX add-to-cart
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = this.querySelector('[name="id"]');
      var qtyInputEl = this.querySelector('[name="quantity"]');
      if (!variantInput) return;
      var variantId = variantInput.value;
      var qty = qtyInputEl ? parseInt(qtyInputEl.value) : 1;
      var btn = this.querySelector('button[type="submit"]');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          updateCartCount();
          window.location.href = '/cart';
        })
        .catch(function(err) {
          console.error(err);
          if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
        });
    });
  });

  // ---- PRODUCT SPEC ACCORDION ----
  // Wraps long spec sections (marked as a lone <p><strong>Label</strong></p>
  // followed by its content) into collapsed <details class="spec-group">
  // blocks. Works uniformly across every product's description, no per-
  // product markup needed, and safely skips descriptions that already have
  // a hand-built <details> (leave those alone) or that have no such
  // markers at all (short blurbs, narrative copy stay as-is).
  var descEl = document.querySelector('.product-desc');
  if (descEl && !descEl.querySelector('details')) {
    var children = Array.prototype.slice.call(descEl.children);

    var isMarker = function (el) {
      if (el.tagName !== 'P') return false;
      if (el.children.length !== 1 || el.children[0].tagName !== 'STRONG') return false;
      var strongText = el.children[0].textContent.trim();
      if (el.textContent.trim() !== strongText) return false;
      if (strongText === '') return false;
      var colonIdx = strongText.indexOf(':');
      // Exclude inline facts like "Quantity Per Case: 12 units" where real
      // content follows the colon inside the same bolded line - a true
      // section marker has nothing (or nothing but the colon) after it.
      if (colonIdx !== -1 && colonIdx < strongText.length - 1) return false;
      return true;
    };

    var markerIdxs = [];
    children.forEach(function (el, i) {
      if (isMarker(el)) markerIdxs.push(i);
    });

    if (markerIdxs.length > 0) {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < markerIdxs[0]; i++) frag.appendChild(children[i]);

      markerIdxs.forEach(function (startIdx, mi) {
        var endIdx = mi + 1 < markerIdxs.length ? markerIdxs[mi + 1] : children.length;
        var label = children[startIdx].textContent.trim().replace(/:\s*$/, '');
        var details = document.createElement('details');
        details.className = 'spec-group';
        var summary = document.createElement('summary');
        summary.textContent = label;
        details.appendChild(summary);
        var contentDiv = document.createElement('div');
        contentDiv.className = 'spec-group-content';
        for (var j = startIdx + 1; j < endIdx; j++) contentDiv.appendChild(children[j]);
        details.appendChild(contentDiv);
        frag.appendChild(details);
      });

      descEl.innerHTML = '';
      descEl.appendChild(frag);
    }
  }

});